import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type ExistingFinancingIconProps = CommonSvgProps

const ExistingFinancingIcon: React.FC<ExistingFinancingIconProps> = React.forwardRef<
  SVGSVGElement,
  ExistingFinancingIconProps
>((props, ref) => (
  <Svg viewBox="0 0 80 80" {...props} ref={ref} color="none">
    <rect x="10.9126" y="30.3877" width="19" height="39" fill="#7BB835" />
    <path
      d="M63.3333 10H16.6667C12.9848 10 10 12.9848 10 16.6667V63.3333C10 67.0152 12.9848 70 16.6667 70H63.3333C67.0152 70 70 67.0152 70 63.3333V16.6667C70 12.9848 67.0152 10 63.3333 10Z"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 30H70"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30 70V30"
      stroke="#51565C"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.0931 53.7325C54.0931 54.7656 53.735 55.6424 53.0188 56.3629C52.3025 57.0835 51.2644 57.5203 49.9042 57.6734V59.816H48.4236V57.6925C47.5329 57.6287 46.6903 57.4566 45.8958 57.176C45.1014 56.8954 44.4694 56.5383 44 56.1047L44.8125 54.1725C45.2579 54.5551 45.7995 54.8771 46.4375 55.1386C47.0755 55.4 47.7375 55.5626 48.4236 55.6264V51.8003C47.569 51.5835 46.8558 51.3444 46.284 51.0829C45.7123 50.8215 45.2338 50.4389 44.8486 49.9351C44.4634 49.4313 44.2708 48.765 44.2708 47.936C44.2708 46.9029 44.6259 46.0229 45.3361 45.296C46.0463 44.569 47.0755 44.1354 48.4236 43.9951V41.8334H49.9042V43.9569C50.5782 43.9951 51.2373 44.1163 51.8813 44.3203C52.5252 44.5244 53.088 44.7922 53.5694 45.1238L52.8292 47.056C51.9143 46.4948 50.9394 46.1505 49.9042 46.0229V49.8873C50.7708 50.1041 51.49 50.34 52.0618 50.5951C52.6336 50.8502 53.115 51.2296 53.5063 51.7334C53.8975 52.2371 54.0931 52.9035 54.0931 53.7325ZM46.6 47.8212C46.6 48.2421 46.7565 48.58 47.0694 48.8351C47.3824 49.0902 47.8338 49.307 48.4236 49.4855V46.0803C47.8097 46.1824 47.3523 46.3864 47.0514 46.6925C46.7505 46.9986 46.6 47.3748 46.6 47.8212ZM49.9042 55.5882C50.5421 55.4861 51.0146 55.2884 51.3215 54.9951C51.6285 54.7018 51.7819 54.3383 51.7819 53.9047C51.7819 53.4711 51.6194 53.1235 51.2944 52.8621C50.9694 52.6006 50.506 52.3806 49.9042 52.2021V55.5882Z"
      fill="#53A2D9"
    />
    <mask
      id="mask0_1192_1956"
      style={{maskType: 'alpha'}}
      maskUnits="userSpaceOnUse"
      x="44"
      y="41"
      width="11"
      height="19"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.0931 53.7325C54.0931 54.7656 53.735 55.6424 53.0188 56.3629C52.3025 57.0835 51.2644 57.5203 49.9042 57.6734V59.816H48.4236V57.6925C47.5329 57.6287 46.6903 57.4566 45.8958 57.176C45.1014 56.8954 44.4694 56.5383 44 56.1047L44.8125 54.1725C45.2579 54.5551 45.7995 54.8771 46.4375 55.1386C47.0755 55.4 47.7375 55.5626 48.4236 55.6264V51.8003C47.569 51.5835 46.8558 51.3444 46.284 51.0829C45.7123 50.8215 45.2338 50.4389 44.8486 49.9351C44.4634 49.4313 44.2708 48.765 44.2708 47.936C44.2708 46.9029 44.6259 46.0229 45.3361 45.296C46.0463 44.569 47.0755 44.1354 48.4236 43.9951V41.8334H49.9042V43.9569C50.5782 43.9951 51.2373 44.1163 51.8813 44.3203C52.5252 44.5244 53.088 44.7922 53.5694 45.1238L52.8292 47.056C51.9143 46.4948 50.9394 46.1505 49.9042 46.0229V49.8873C50.7708 50.1041 51.49 50.34 52.0618 50.5951C52.6336 50.8502 53.115 51.2296 53.5063 51.7334C53.8975 52.2371 54.0931 52.9035 54.0931 53.7325ZM46.6 47.8212C46.6 48.2421 46.7565 48.58 47.0694 48.8351C47.3824 49.0902 47.8338 49.307 48.4236 49.4855V46.0803C47.8097 46.1824 47.3523 46.3864 47.0514 46.6925C46.7505 46.9986 46.6 47.3748 46.6 47.8212ZM49.9042 55.5882C50.5421 55.4861 51.0146 55.2884 51.3215 54.9951C51.6285 54.7018 51.7819 54.3383 51.7819 53.9047C51.7819 53.4711 51.6194 53.1235 51.2944 52.8621C50.9694 52.6006 50.506 52.3806 49.9042 52.2021V55.5882Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1192_1956)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39 43C39 41.8954 39.8954 41 41 41H57C58.1046 41 59 41.8954 59 43V59C59 60.1046 58.1046 61 57 61H41C39.8954 61 39 60.1046 39 59V43Z"
        fill="#53A2D9"
      />
    </g>
  </Svg>
))

ExistingFinancingIcon.propTypes = commonPropTypes
ExistingFinancingIcon.defaultProps = commonDefaultProps

export default ExistingFinancingIcon
